export default __webpack_public_path__ + "static/media/runkeeper-interval-after-3.bbc205a1.jpg";